import { useEffect, useState, useRef } from "react"
import { btnOne, tableHeader } from "../utils/style"
import fetchData from "../custom_functions/fetchData";
import { useRecoilState } from "recoil";
import uiConfigAtom from "../atoms/uiConfigAtom";
import Button from "./Button";
import { setLoader } from "./Loader";
import { FaChevronLeft, FaChevronRight, FaFilter, FaSearch, FaTimes } from "react-icons/fa";

function Table({ tableData, url, options, pagination, clickHandler, btnTitle, rowClickHandler, noFilter, noButton, excludeFilter, reloadTable, setViewData = null, isMultiSelect = false, selectedRows = [], setSelectedRows = null, multiSelectedKeyPair = null }) {

    {/* If isMultiSelect : true and you want some records already checked then pass multiSelectedKeyPair (ex: { key: "status", value: "Invoiced" }) as params
      to get date componant for filter pass {isDateFilter: true}*/ }

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(false);
    const [page, setPage] = useState(1);
    const [uiConfig] = useRecoilState(uiConfigAtom)
    const [filterData, setFilterData] = useState({})
    const [active, setActive] = useState('')
    const excludeFilters = excludeFilter || []
    const tableRef = useRef(null);

    const toggleFilter = (header) => {
        setActive(prevState => prevState === header ? '' : header);
    };

    useEffect(() => {
        getData(filterData)
    }, [tableData ? tableData : page, reloadTable])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tableRef.current && !tableRef.current.contains(event.target)) {
                setActive('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, []);

    function togglePage(type) {
        if (type === 'prev' && page > 1) {
            setPage(page - 1)
        }

        if (type === 'next') {
            setPage(page + 1)
        }
    }

    async function getData(filterData) {
        if (!tableData) {
            setLoader(true)
            let reqUrl = url + '?';
            if (pagination) {
                reqUrl = reqUrl + `page=${page}&`
            }
            if (Object.keys(filterData).length > 0) {
                for (let i in filterData) {
                    reqUrl += i + '=' + filterData[i] + '&'
                }
            }
            fetchData(reqUrl, (err) => { console.log(err); setLoader(false) }, (data) => { setData(data.data); setIsNextPage(data.isNextPage || false); setLoader(false) })
        } else {
            setData(tableData)
        }
    }

    function updateFilterData(e) {
        const { name, value } = e.target;
        const data = { ...filterData };
        if (value === '') {
            delete data[name]
        } else {
            data[name] = value;
        }
        setFilterData(data)
    }

    function resetField(field) {
        const data = { ...filterData }
        delete data[field]
        setFilterData(data)
        getData(data)
    }

    const headerStyle = {
        backgroundColor: uiConfig?.table?.headerColor?.hex || '#F9FAFB',
        color: uiConfig?.table?.fontColor?.hex || '#1F2937'
    }

    return (
        <div
            className="w-full bg-white rounded-xl border border-neutral-200 shadow-md overflow-hidden"
        >
            {/* Header Section */}
            {!noButton && (
                <div className="flex justify-between items-center px-8 py-6 border-b border-neutral-200 bg-gradient-to-r from-neutral-50 to-white">
                    <div className="flex items-center gap-4">
                        <div className="h-12 w-1 rounded-full bg-gradient-to-b from-primary to-primary-dark"></div>
                        <div className="flex flex-col gap-1">
                            <h2 className="text-xl font-bold text-neutral-900">Overview</h2>
                            {data.length > 0 && (
                                <span className="inline-flex w-fit px-3 py-1 bg-primary-light text-primary text-xs font-semibold rounded-full border border-primary">
                                    {data.length} items
                                </span>
                            )}
                        </div>
                    </div>
                    <Button
                        name={`+ Add ${btnTitle}`}
                        clickHandler={() => clickHandler()}
                        size="md"
                        variant="primary"
                    />
                </div>
            )}

            {/* Table Container */}
            <div className="overflow-x-auto">
                <table ref={tableRef} className="w-full">
                    <thead>
                        <tr className="bg-neutral-50 border-b border-neutral-200">
                            {isMultiSelect && (
                                <th className="px-8 py-5 text-left">
                                    <div className="flex items-center justify-center">
                                        <div className="w-5 h-5 border-2 border-neutral-300 rounded-sm bg-white cursor-pointer"></div>
                                    </div>
                                </th>
                            )}
                            {options.map((opt, ind) => (
                                <th
                                    key={ind}
                                    className="px-8 py-5 text-left font-semibold text-neutral-700 tracking-wider"
                                    style={{ ...headerStyle, width: opt.width ? opt.width : 'auto' }}
                                >
                                    <div className="relative flex items-center justify-between gap-3 group">
                                        <span className="text-sm font-semibold text-neutral-700 uppercase tracking-wide">{opt.header}</span>

                                        {!noFilter && !excludeFilters.includes(opt.header) && (
                                            <div className="flex items-center gap-2">
                                                <button
                                                    onClick={() => toggleFilter(opt.header)}
                                                    className="p-2 text-neutral-600 hover:text-white hover:bg-primary rounded-lg border border-transparent transition-all duration-200 shadow-sm"
                                                >
                                                    <FaFilter size={14} />
                                                </button>
                                                {filterData[opt.filterKey || opt.key] && (
                                                    <button
                                                        onClick={() => resetField(opt.filterKey || opt.key)}
                                                        className="p-2 text-danger hover:text-white hover:bg-danger rounded-lg border border-transparent transition-all duration-200"
                                                    >
                                                        <FaTimes size={14} />
                                                    </button>
                                                )}
                                            </div>
                                        )}

                                        {/* Filter Dropdown */}
                                        {!noFilter && opt.header === active && (
                                            <div className="absolute top-14 left-0 z-50 bg-white rounded-xl shadow-xl border border-neutral-200 p-5 min-w-72">
                                                <div className="space-y-4">
                                                    <div className="flex items-center gap-2 bg-neutral-50 rounded-lg px-4 py-2.5">
                                                        <FaSearch className="text-primary" size={16} />
                                                        <input
                                                            type={(opt.key === "date" || opt.isDateFilter === true) ? "date" : "text"}
                                                            name={opt.filterKey || opt.key}
                                                            value={filterData[opt.filterKey || opt.key] || ''}
                                                            className="flex-1 bg-transparent text-sm outline-none placeholder:text-neutral-400"
                                                            placeholder={`Filter ${opt.header.toLowerCase()}...`}
                                                            onChange={updateFilterData}
                                                        />
                                                    </div>
                                                    <div className="flex gap-3">
                                                        <button
                                                            className="flex-1 px-4 py-2.5 bg-primary text-white text-sm font-semibold rounded-lg hover:bg-primary-dark transition-colors duration-200 shadow-base"
                                                            onClick={() => { setActive(''); getData(filterData) }}
                                                        >
                                                            Apply Filter
                                                        </button>
                                                        <button
                                                            className="px-4 py-2.5 text-primary text-sm font-semibold border border-primary rounded-lg hover:bg-primary-light transition-colors duration-200"
                                                            onClick={() => setActive('')}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-neutral-100">
                        {data?.length > 0 ? (
                            data.map((dt, ind) => {
                                const isChecked = selectedRows?.some(row => row.id === dt.id);

                                return (
                                    <tr
                                        key={ind}
                                        className="hover:bg-green-50/70 transition-colors duration-150 cursor-pointer group"
                                        onClick={(e) => {
                                            rowClickHandler?.(ind);
                                            setViewData?.(dt);
                                        }}
                                    >
                                        {isMultiSelect && (
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center">
                                                    {multiSelectedKeyPair && dt[multiSelectedKeyPair.key] === multiSelectedKeyPair.value ? (
                                                        <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                                                            <span className="text-green-600 text-xs font-bold">✓</span>
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="checkbox"
                                                            checked={isChecked}
                                                            onChange={(e) => {
                                                                let updatedRows = [];
                                                                if (e.target.checked) {
                                                                    updatedRows = [...selectedRows, dt];
                                                                } else {
                                                                    updatedRows = selectedRows.filter(row => row.id !== dt.id);
                                                                }
                                                                setSelectedRows?.(updatedRows);
                                                            }}
                                                            className="w-4 h-4 text-emerald-600 bg-white border-emerald-200 rounded focus:ring-emerald-500 focus:ring-2"
                                                        />
                                                    )}
                                                </div>
                                            </td>
                                        )}
                                        {options.map((opt, indx) => (
                                            <td key={indx} className="px-6 py-4">
                                                <div className="text-sm text-gray-900 group-hover:text-emerald-800 transition-colors duration-150">
                                                    {opt.render ? opt.render(dt, ind) : dt[opt.key]}
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td className="px-6 py-12 text-center" colSpan={options.length + (isMultiSelect ? 1 : 0)}>
                                    <div className="flex flex-col items-center space-y-3">
                                        <div className="w-16 h-16 bg-emerald-50 border border-emerald-100 rounded-full flex items-center justify-center">
                                            <svg className="w-8 h-8 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-emerald-700 font-medium">No data found</p>
                                            <p className="text-emerald-500 text-sm">Try adjusting your filters or add new data</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {pagination && (
                <div className="flex items-center justify-between px-6 py-4 bg-gradient-to-r from-green-50 via-white to-green-50 border-t border-green-100">
                    <div className="text-sm text-emerald-700">
                        Page {page} of results
                    </div>
                    <div className="flex items-center space-x-2">
                        <button
                            type="button"
                            className="flex items-center space-x-2 px-4 py-2 text-sm font-semibold text-emerald-700 bg-white border border-emerald-200 rounded-full hover:bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-300 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                            onClick={() => togglePage('prev')}
                            disabled={page === 1}
                        >
                            <FaChevronLeft size={12} />
                            <span>Previous</span>
                        </button>

                        <div className="flex items-center space-x-1">
                            <span className="px-3 py-2 text-sm font-semibold text-white bg-gradient-to-r from-emerald-500 to-green-600 rounded-full shadow-sm shadow-emerald-400/30">
                                {page}
                            </span>
                        </div>

                        <button
                            type="button"
                            className="flex items-center space-x-2 px-4 py-2 text-sm font-semibold text-emerald-700 bg-white border border-emerald-200 rounded-full hover:bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-300 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                            onClick={() => togglePage('next')}
                            disabled={!isNextPage}
                        >
                            <span>Next</span>
                            <FaChevronRight size={12} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Table;